import { Comparator }	from "ts-base/comparator";

import { Textual }	from "@v3/data/textual";
import { IsoTimeM }	from "@v3/data/time/isoTimeM";

// hh:mm:ss
export type IsoTimeS	= Textual.Value<typeof Base>;

const Base	=
	Textual.regex(
		"IsoTimeS",
		/^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/,
		"must be an iso-8601 time in hh:mm:ss format"
	);

namespace Extension {
	export const getIsoTimeM	= (it:IsoTimeS):IsoTimeM	=>
		IsoTimeM.brand(it.slice(0, 5));

	export const compare	= Comparator.builtinOf<IsoTimeS>();
}

export const IsoTimeS	= { ...Extension, ...Base };
